import { CalendarDays } from 'lucide-react';

const RecentActivity = () => {
  const notifications = [
    {
      date: '5 Nov 2024',
      time: '4:16pm',
      message: 'You received a mail from Something Manufacturer',
      actionText: 'view',
    },
    {
      date: '5 Nov 2024',
      time: '4:16pm',
      message:
        'Hey Somesh! Your RFQ confirmation for Quote number 245668 is remaining',
      actionText: 'Review Now',
    },
    {
      date: '4 Nov 2024',
      time: '3:45pm',
      message: 'Your quote has been approved by ACME Corp',
      actionText: 'Check',
    },
    {
      date: '3 Nov 2024',
      time: '11:30am',
      message: 'You received feedback for your recent RFQ submission',
      actionText: 'View Feedback',
    },
  ];

  const messages = [
    {
      date: '5 Nov 2024',
      time: '4:16pm',
      sender: 'Samridhi Industries',
      content: 'Can you send the quote with this mentioned updates',
    },
    {
      date: '5 Nov 2024',
      time: '4:16pm',
      sender: 'Samridhi Industries',
      content: 'Reminders on your RFQ',
    },
    {
      date: '5 Nov 2024',
      time: '4:16pm',
      sender: 'Samridhi Industries',
      content: 'Reminders on your RFQ',
    },
    {
      date: '5 Nov 2024',
      time: '4:16pm',
      sender: 'Samridhi Industries',
      content: 'Reminders on your RFQ',
    },
  ];

  return (
    <div className="p-4">
      <h2 className="font-semibold text-base mb-4">Recent Activity</h2>

      {/* Notifications */}
      <div className="mb-6 px-2">
        <h3 className="font-semibold text-gray-600 text-xs mb-4">
          Notifications
        </h3>
        <div
          className="space-y-4 max-h-[400px] overflow-y-auto sidebarScroller"
          style={{
            scrollbarWidth: 'none',
            scrollbarColor: '#b0b0b0 #f0f0f0',
          }}
        >
          {notifications.map((notification, index) => (
            <div
              key={index}
              className="p-2 rounded-lg bg-gray-50 flex flex-col space-y-3"
            >
              <div className="w-full flex flex-row justify-between items-center text-xs text-slate-600 font-medium">
                <div className="flex items-center">
                  <CalendarDays className="w-3 h-3 mr-1" />
                  {notification.date}
                </div>
                <div>{notification.time}</div>
              </div>
              <div className="px-2 text-sm">{notification.message}</div>
              <button className="py-1 px-2 rounded border self-end text-lightPurple text-sm font-semibold bg-white hover:bg-veryLightPurple hover:bg-opacity-15">
                {notification.actionText}
              </button>
            </div>
          ))}
        </div>
      </div>

      {/* Messages */}
      <div className="px-2">
        <h3 className="font-semibold text-gray-600 text-xs mb-4">Messages</h3>
        <div
          className="space-y-4 max-h-[400px] overflow-y-auto thin-scrollbar"
          style={{
            scrollbarWidth: 'none',
            scrollbarColor: '#b0b0b0 #f0f0f0',
          }}
        >
          {messages.map((message, index) => (
            <div
              key={index}
              className="p-4 border rounded-lg bg-gray-50 flex flex-col space-y-3"
            >
              <div className="w-full flex flex-row justify-between items-center text-xs text-slate-600 font-medium">
                <div className="flex items-center">
                  <CalendarDays className="w-3 h-3 mr-1" />
                  {message.date}
                </div>
                <div>{message.time}</div>
              </div>
              <div>
                <p className="text-sm font-semibold text-gray-800 mt-1">
                  {message.sender}
                </p>
                <p className="text-sm text-gray-600">{message.content}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RecentActivity;
